import { create } from "zustand";

const TOKEN_KEY = "chicago_access_token";

const useAuthStore = create((set) => ({
  accessToken: localStorage.getItem(TOKEN_KEY) ?? null,
  setAccessToken: (accessToken) => {
    if (accessToken) {
      localStorage.setItem(TOKEN_KEY, accessToken);
    } else {
      localStorage.removeItem(TOKEN_KEY);
    }
    set({ accessToken });
  },
  clearTokens: () => {
    localStorage.removeItem(TOKEN_KEY);
    set({ accessToken: null });
  },
}));

export default useAuthStore;

export const getAccessToken = () => useAuthStore.getState().accessToken;
export const setAccessToken = (token) =>
  useAuthStore.getState().setAccessToken(token);
export const clearTokens = () => useAuthStore.getState().clearTokens();
